import { render } from "./GridTabCampanii.vue?vue&type=template&id=6df41a66&scoped=true&ts=true"
import script from "./GridTabCampanii.vue?vue&type=script&lang=ts"
export * from "./GridTabCampanii.vue?vue&type=script&lang=ts"

import "./GridTabCampanii.vue?vue&type=style&index=0&id=6df41a66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df41a66"]])

export default __exports__